import { css, styled } from '@mui/material';

import { MIDDLE_RADIUS_PX, TINY_MARGIN_PX } from '~/theme';
import { ComponentVariants } from '~/ui/util/types';

type TagVariant = 'default' | 'shrink';

const tagVariants: ComponentVariants<TagVariant> = {
  default: () => css`
    padding: 4px 14px;
  `,
  shrink: () => css`
    padding: 4px ${TINY_MARGIN_PX};
  `,
};

export interface TagProps {
  variant?: TagVariant;
}

export const Tag = styled('div', { shouldForwardProp: (prop) => prop !== 'variant' })<TagProps>`
  display: inline-flex;
  border-radius: ${MIDDLE_RADIUS_PX};
  background-color: ${({ theme }) => theme.palette.common.green};
  color: ${({ theme }) => theme.palette.common.button.color};
  font-size: 12px;
  line-height: 14px;
  font-weight: 400;

  ${({ variant }) => tagVariants[variant || 'default']()}
`;
